import Promise from 'bluebird';
import { PageAPI } from 'lib/api';
import { scoreBuckets } from 'lib/scorekeeper';
import scheduleModuleBucketsSelector from 'selectors/scheduleModuleBucketsSelector';
import routeSelector from 'selectors/routeSelector';
import { countrySelector } from 'selectors/appSelector';
import { Route } from 'enums';
import { getMinutesUntilStart } from 'lib/format';
import uniqBy from 'lodash/uniqBy';

export const REQUEST_SCHEDULE_MODULE_DATA = 'REQUEST_SCHEDULE_MODULE_DATA';
export const RECEIVE_SCHEDULE_MODULE_DATA = 'RECEIVE_SCHEDULE_MODULE_DATA';
export const SCORE_SCHEDULE_MODULE_DATA = 'SCORE_SCHEDULE_MODULE_DATA';

const pageName = 'scheduleModule';

function decayContentScoreWithTime(content) {
    const DECAY_THRESHOLD = 30; // minutes until start time
    const minutesUntilStart = getMinutesUntilStart(content);

    if (minutesUntilStart >= DECAY_THRESHOLD) {
        content.score -= minutesUntilStart;
    }
    return content;
}

function dedupeBucketContents(buckets = []) {
    return buckets.map((bucket) => {
        const dedupedContents = uniqBy(bucket.contents || [], 'name');
        bucket.contents = dedupedContents;
        return bucket;
    });
}

function scoreBucketsWithTime(buckets = []) {
    return buckets.map((bucket) => {
        const scoredContents = bucket.contents.map((content) => decayContentScoreWithTime(content))
            .sort((aContent, bContent) => {
                if (aContent.score > bContent.score) {
                    return -1;
                } else if (aContent.score < bContent.score) {
                    return 1;
                }
                return 0;
            });
        bucket.contents = scoredContents;
        return bucket;
    });
}

export function fetchScheduleModule(query, lang = 'en') {
    return (dispatch, getState) => {
        const savedBuckets = scheduleModuleBucketsSelector(getState());
        const country = countrySelector(getState());
        if (savedBuckets.length > 0) {
            return Promise.resolve();
        }

        dispatch({
            type: REQUEST_SCHEDULE_MODULE_DATA,
            requestedTime: Date.now()
        });

        return PageAPI.getPage(pageName, query, lang, null, country).then((response) => {
            const { page: { buckets = [] } = {} } = response;
            if (buckets.length > 0) {
                const timeScoredBuckets = dedupeBucketContents(scoreBucketsWithTime(buckets));
                dispatch({
                    type: RECEIVE_SCHEDULE_MODULE_DATA,
                    buckets: timeScoredBuckets,
                    receivedTime: Date.now()
                });
            }
        });
    };
}

export function scoreScheduleModule() {
    return (dispatch, getState) => {
        const state = getState();
        const route = routeSelector(state);
        // no schedule module exists on schedule page
        if (route === Route.SCHEDULE) {
            return Promise.resolve();
        }
        const buckets = state.scheduleModule.buckets;
        const influencers = state.scoring.influencers;
        const preferences = state.fan.preferences;
        return scoreBuckets(buckets, preferences, influencers)
            .then((scoredBuckets) => {
                const scoredBucketsWithTime = scoreBucketsWithTime(scoredBuckets);
                dispatch({
                    type: SCORE_SCHEDULE_MODULE_DATA,
                    buckets: scoredBucketsWithTime,
                    receivedTime: Date.now()
                });
            });
    };
}



// WEBPACK FOOTER //
// ./app/scheduleModule/actions/index.js